const customerEndpointsQueryKeys = {
    all: ['customer_endpoints'] as const,
    list: (accountId: string) => [...customerEndpointsQueryKeys.all, accountId, 'list'] as const,
};

export default customerEndpointsQueryKeys;
